import PropTypes from "prop-types";

export const BIT_PROP_TYPES = {
  campaign: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    video: PropTypes.shape({
      orientation: PropTypes.oneOf(["portrait", "landscape"]),
      src: PropTypes.shape({
        poster: PropTypes.string,
        mp4: PropTypes.string,
        webm: PropTypes.string,
      }),
    }),
    meta: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      canonicalUrl: PropTypes.string.isRequired,
    }),
  }),
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    meta: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    media: PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        credit: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
    }),
  }),
  destination: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    meta: PropTypes.shape({
      category: PropTypes.string.isRequired,
      parent: PropTypes.string.isRequired,
    }).isRequired,
    editorial: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(["p", "ol", "blockquote", "video"]),
        children: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.arrayOf(PropTypes.string),
        ]),
      })
    ).isRequired,
    media: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(["video", "image"]),
        orientation: PropTypes.oneOf(["portrait", "landscape"]),
        credit: PropTypes.string,
        src: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            poster: PropTypes.string,
            mp4: PropTypes.string,
            webm: PropTypes.string,
            jwvid: PropTypes.string,
          }).isRequired,
        ]),
      })
    ),
    articles: PropTypes.arrayOf(PropTypes.string),
  }),
  video: PropTypes.shape({
    type: PropTypes.oneOf(["video"]),
    orientation: PropTypes.oneOf(["portrait", "landscape"]),
    src: PropTypes.shape({
      poster: PropTypes.string,
      mp4: PropTypes.string,
      webm: PropTypes.string,
      jwvid: PropTypes.string,
    }),
  }),
  imgixParams: PropTypes.shape({
    auto: PropTypes.oneOf(["compress", "format", "enhance", "redeye"]),
    fit: PropTypes.oneOf([
      "crop",
      "clip",
      "facearea",
      "fill",
      "max",
      "min",
      "scale",
    ]),
    crop: PropTypes.oneOf([
      "top",
      "left",
      "right",
      "bottom",
      "faces",
      "entropy",
      "focalpoint",
    ]),
    ar: PropTypes.string,
    bri: PropTypes.number,
    con: PropTypes.number,
    sat: PropTypes.number,
    sharp: PropTypes.number,
    usm: PropTypes.arrayOf(PropTypes.number),
    hue: PropTypes.number,
    invert: PropTypes.bool,
    sepia: PropTypes.number,
    format: PropTypes.oneOf(["jpg", "png", "gif", "webp"]),
    blur: PropTypes.number,
    halign: PropTypes.oneOf(["left", "center", "right"]),
    valign: PropTypes.oneOf(["top", "middle", "bottom"]),
    bg: PropTypes.string,
    q: PropTypes.number,
    w: PropTypes.number,
    h: PropTypes.number,
  }),
};
